import React, {useEffect, useState} from "react";
import {IoIosAddCircleOutline} from "react-icons/io";
import {Checkbox, ConfigProvider, Dropdown, notification, Spin, Switch} from "antd"; // Import ConfigProvider
import "./goal-box.scss";
import {RoundedCheck} from "../../../../../assets/icons/defaultIcons";
import {LoadingOutlined} from '@ant-design/icons';
import {DeleteTarget, UpdateTarget} from "../../../../services/target-api.service";
import {BsThreeDots} from "react-icons/bs";
import ActionModal from "../../../../components/common/modals/action-modal/ActionModal";
import ThemeModals from "../../../../components/common/modals/theme-modals/ThemeModals";
import EditTarget from "./EditTarget";

export default function TargetBox({
                                      GoalHeading,
                                      GoalEmptyHeading,
                                      GoalIcon,
                                      boxColor,
                                      iconColor,
                                      Color,
                                      backgroundColor,
                                      hasSwitch = false,
                                      children,
                                      onClick,
                                      data,
                                      loader,
                                      getListing,
                                      setGetListing,
                                      onDuplicate
                                  }) {
    const [isVisible, setIsVisible] = useState(true);
    const [goals, setGoals] = useState([]);
    const [deleteTarget, setDeleteTarget] = useState(false);
    const [loaderDelete, setLoaderDelete] = useState(false);
    const [targetToDelete, setTargetToDelete] = useState(null);
    const [editTarget, setEditTarget] = useState(false);
    const [targetToEdit, setTargetToEdit] = useState(null);
    const [animatingItems, setAnimatingItems] = useState(new Set());
    const [loadingItems, setLoadingItems] = useState(new Set());

    console.log("ThisIsDataTask",data)

    useEffect(() => {
        if(data?.length > 0){
            // Sort the incoming data: unchecked first, then checked
            const sortedData = [...data].sort((a, b) => {
                if (a.isDone === b.isDone) return 0;
                return a.isDone ? 1 : -1; // false (unchecked) comes first
            });
            setGoals(sortedData);
        } else {
            setGoals([]);
        }
    }, [data]);
    console.log("goalsTarget",goals)

    const categoryIcon = [
        {
            pillarType : 'Faith',
            icon: 'https://s3.amazonaws.com/riseup-backend/VrX2HhpHowzA'
        },
        {
            pillarType :'Family',
            icon: 'https://s3.amazonaws.com/riseup-backend/2E0z0JloaIKP'
        },
        {
            pillarType : 'Fitness',
            icon: 'https://s3.amazonaws.com/riseup-backend/KXGBI4jGBJcH'
        },
        {
            pillarType : 'Finance',
            icon: 'https://s3.amazonaws.com/riseup-backend/ZmxcOFkt6NVx'
        }
    ]

    // Function to play success sound
    const playSuccessSound = () => {
        try {
            // Create a pleasant success chime using Web Audio API
            const audioContext = new (window.AudioContext || window.webkitAudioContext)();
            
            // Create multiple oscillators for a richer chord sound
            const frequencies = [523.25, 659.25, 783.99]; // C5, E5, G5 (C major chord)
            const duration = 0.6;
            
            frequencies.forEach((freq, index) => {
                const oscillator = audioContext.createOscillator();
                const gainNode = audioContext.createGain();
                
                oscillator.connect(gainNode);
                gainNode.connect(audioContext.destination);
                
                // Set frequency for each note in the chord
                oscillator.frequency.setValueAtTime(freq, audioContext.currentTime);
                oscillator.type = 'sine'; // Smooth sine wave
                
                // Create a gentle fade in and out
                const startTime = audioContext.currentTime + (index * 0.05); // Slight delay between notes
                const volume = 0.15 - (index * 0.03); // Decreasing volume for harmony
                
                gainNode.gain.setValueAtTime(0, startTime);
                gainNode.gain.linearRampToValueAtTime(volume, startTime + 0.05);
                gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + duration);
                
                oscillator.start(startTime);
                oscillator.stop(startTime + duration);
            });
            
        } catch (error) {
            console.log("Audio not supported or blocked");
        }
    };

    async function handleDeleteTarget(id) {
        try {
            setLoaderDelete(true);
            const response = await DeleteTarget(id); // Using imported DeleteTarget
            if (response?.data?.data?.status) {
                notification.success({
                    message: "Success",
                    description: "Target deleted successfully",
                    placement: "topRight",
                    icon: <RoundedCheck />,
                    duration: 2,
                });
                // Update goals state by filtering out the deleted target
                setGoals(prevGoals => prevGoals.filter(goal => goal._id !== id));
            }
        } catch (error) {
            notification.error({
                message: "Error",
                description: "Failed to delete target",
                placement: "topRight",
                duration: 2,
            });
        } finally {
            setDeleteTarget(false);
            setLoaderDelete(false);
            setTargetToDelete(null);
        }
    }

    async function handleUpdateGoal(itemId, payload) {
        try {
            const response = await UpdateTarget(itemId, payload);
            if ( response?.data?.data?.status) {
                notification.success({
                    message: "Success",
                    description:response?.data?.data?.message,
                    placement: "topRight",
                    icon: <RoundedCheck />,
                    duration: 2,
                });
            }

        } catch (error) {
            throw error;
        }
    }

    const onChange = async (e, item) => {
        const checked = e.target.checked;
        const previousGoals = [...goals];
        
        // Prevent multiple clicks on the same item
        if (loadingItems.has(item._id)) {
            e.preventDefault();
            return;
        }
        
        // Don't update UI immediately - wait for API response
        // Revert checkbox to previous state first
        e.target.checked = item.isDone;
        
        // Add loading state
        setLoadingItems(prev => new Set([...prev, item._id]));

        try {
            // Call API first
            await handleUpdateGoal(item._id, { isDone: checked });
            
            // Only update UI after successful API response
            const updatedGoals = goals.map(g =>
                g._id === item._id ? { ...g, isDone: checked } : g
            );
            
            // Sort the goals: unchecked first, then checked (mimics backend behavior)
            const sortedGoals = updatedGoals.sort((a, b) => {
                if (a.isDone === b.isDone) return 0;
                return a.isDone ? 1 : -1; // false (unchecked) comes first
            });
            
            // Update UI with sorted data
            setGoals(sortedGoals);
            
            // Add animation only after successful API call
            if (checked) {
                setAnimatingItems(prev => new Set([...prev, item._id]));
                playSuccessSound();
                
                // Remove animation after 2 seconds
                setTimeout(() => {
                    setAnimatingItems(prev => {
                        const newSet = new Set(prev);
                        newSet.delete(item._id);
                        return newSet;
                    });
                }, 2000);
            }
            
        } catch (error) {
            // Revert to previous state on error - no UI changes
            notification.error({
                message: "Error",
                description: "Failed to update target status",
                placement: "topRight",
                duration: 2,
            });
        } finally {
            // Remove loading state
            setLoadingItems(prev => {
                const newSet = new Set(prev);
                newSet.delete(item._id);
                return newSet;
            });
        }
    };

    return (
        <ConfigProvider
            theme={{
                components: {
                    Checkbox: {
                        colorPrimary: "#D2A84E", // Main color for checkbox
                        colorPrimaryHover: "#FDFF9F", // Hover effect
                        borderRadius: 4,
                        controlHeight: 24
                    }
                }
            }}
        >
            <div className="goals-box">
                <div className="goals-box-header">
                    <h3 style={{ color: boxColor }}>
                        {GoalIcon && (
                            <span style={{ backgroundColor: backgroundColor }}>
                                <img src={GoalIcon} alt={GoalHeading} />
                            </span>
                        )}
                        <div className="header-content">
                            {GoalHeading}
                            {hasSwitch && (
                                <div className="switch-wrapper">
                                    {isVisible ? 'Hide' : 'Show'}
                                    <Switch
                                        checked={isVisible}
                                        onChange={(checked) => setIsVisible(checked)}
                                        style={{
                                            width: "46px",
                                            height: "24px"
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </h3>
                </div>
                <div className="goal-box-body" style={{ backgroundColor: backgroundColor }}>
                    {children ||
                    (goals.length > 0  ? (
                        <div className="goal-box-body-item">
                            {goals.map((item, index) => (
                                <div 
                                    key={item._id || index} 
                                    className={`theme-radio ${animatingItems.has(item._id) ? 'success-animation' : ''} ${loadingItems.has(item._id) ? 'loading-animation' : ''}`}
                                >
                                    <Checkbox
                                        className={`custom-checkbox ${
                                            item.isDone ? "checked" : ""
                                        }`}
                                        checked={item.isDone}
                                        onChange={(e) => onChange(e, item)}
                                        disabled={loadingItems.has(item._id)}
                                    >
                                       <span className="checkbox-content">
                                           {loadingItems.has(item._id) ? (
                                               <Spin size="small" style={{ marginRight: '8px' }} />
                                           ) : (
                                               item.category && categoryIcon.find(icon => icon.pillarType === item.category)?.icon && (
                                                   <img 
                                                      src={categoryIcon.find(icon => icon.pillarType === item.category)?.icon} 
                                                      alt={item.category}
                                                      style={{ width: '18px', height: '18px', marginRight: '6px' }}
                                                   />
                                               )
                                           )}
                                           {item.goal || item.title}
                                       </span>

                                    </Checkbox>
                                    <span className="check-options">
                                          <Dropdown 
                                            menu={{ 
                                              items: [
                                                {
                                                  key: "1",
                                                  label: (
                                                    <span className={'w-100 d-block'} onClick={() => {
                                                        setTargetToEdit(item);
                                                        setEditTarget(true);
                                                    }}>
                                                        Edit
                                                    </span>
                                                  ),
                                                },
                                                {
                                                  key: "2",
                                                  label: (
                                                    <span className={'w-100 d-block'} onClick={() => {
                                                        setTargetToDelete(item._id);
                                                        setDeleteTarget(true);
                                                    }}>
                                                     Delete
                                                    </span>
                                                  ),
                                                },
                                                  {
                                                      key: "3",
                                                      label: (
                                                          <span className={'w-100 d-block'} onClick={() => {
                                                              if (onDuplicate) {
                                                                  onDuplicate(item);
                                                              }
                                                          }}>
                                                     Duplicate
                                                    </span>
                                                      ),
                                                  },
                                              ]
                                            }} 
                                            placement="bottomLeft" 
                                            trigger={"click"}
                                          >
                                            <BsThreeDots />
                                          </Dropdown>
                                    </span>
                                </div>
                            ))}
                        </div>
                    ) : (
                        // Show "Add Goals" button if no goals are available
                        <div className="goal-box-empty" onClick={onClick}>
                            {
                                loader ?
                                    <div>
                                        <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
                                    </div>
                                    :
                                    <div>

                                       <span className="goal-box-empty-icon" style={{ color: iconColor }}>
                                        <IoIosAddCircleOutline />
                                    </span>
                                        <h4>{GoalEmptyHeading}</h4>
                                    </div>
                            }

                        </div>
                    ))}
                </div>
            </div>

            <ActionModal
                show={deleteTarget}
                close={() => {
                    setDeleteTarget(false);
                    setTargetToDelete(null);
                }}
                modalHeading={"Delete Target"}
                modalText={"Are you sure you want to delete?"}
                cancelBTnText={"Cancel"}
                actionBTnText={"Delete"}
                actionBtnFunc={() => targetToDelete && handleDeleteTarget(targetToDelete)}
                loader={loaderDelete}
            />

            <ThemeModals
                open={editTarget}
                close={setEditTarget}
                title={'Edit Target'}
                content={
                    <EditTarget
                        close={setEditTarget}
                        getListing={getListing}
                        setGetListing={setGetListing}
                        data={targetToEdit}
                    />
                }
            />

        </ConfigProvider>
    );
}
